import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import CountryService from "./CountryCatService";
import CountryServicee from "./CountryService";

export const getANewsCatt = createAsyncThunk(
  "category/getAllCatNewsCatt",
  async (id, thunkAPI) => {
    try {
      return await CountryServicee.getNewsCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getCategories = createAsyncThunk(
  "category/getAllCat",
  async (thunkAPI) => {
    try {
      return await CountryService.getNewsCategories();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getCategoriess = createAsyncThunk(
  "category/getAllCatbyid",
  async (id,thunkAPI) => {
    try {
      return await CountryService.getNewsCategoriess(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createNewNewsCat = createAsyncThunk(
  "category/addCategory",
  async (catData, thunkAPI) => {
    try {
      return await CountryService.createNewsCategory(catData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getANewsCat = createAsyncThunk(
  "category/getCat",
  async ({ id, secondId }, thunkAPI) => {
    try {
      return await CountryService.getNewsCategory(id,secondId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateANewsCat = createAsyncThunk(
  "category/editCategory",
  async ({ id, secondId , NewsCatData }, thunkAPI) => {
    try {
      return await CountryService.updateNewsCategory(id,secondId,NewsCatData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteANewsCat = createAsyncThunk(
  "category/deleteCategory",
  async ({ id, secondId  }, thunkAPI) => {
    try {
      return await CountryService.deleteNewsCategory(id,secondId);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");
const initialState = {
  bCategories: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const pCategorySlice = createSlice({
  name: "bCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.bCategories = action.payload.data;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getCategoriess.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategoriess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.bCategories = action.payload.data;
      })
      .addCase(getCategoriess.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewNewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewNewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createNewsCategory = action.payload;
      })
      .addCase(createNewNewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.categoryName = action.payload.data.categoryName;

        state.description = action.payload.data.description;
        state.link = action.payload.data.link;
        state.type = action.payload.data.type;
        
      })
      .addCase(getANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        
        state.message = action.error;
      })

      .addCase(getANewsCatt.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANewsCatt.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        
      })
      .addCase(getANewsCatt.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        
        state.message = action.error;
      })
      .addCase(updateANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedNewsCategory = action.payload;
      })
      .addCase(updateANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedNewsCategory = action.payload;
      })
      .addCase(deleteANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default pCategorySlice.reducer;
